export const SET_TOUR_HOVER_CARD = "SET_TOUR_HOVER_CARD";
export const SET_TOUR_HOVER_CARD_INDEX = "SET_TOUR_HOVER_CARD_INDEX";
export const SET_TOUR_PROPERTY_ID = "SET_TOUR_PROPERTY_ID";
